import React from 'react';

import { forwardRef } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { AutoResizeInput } from 'uiToolkitV1/AutoResizeInput';

const StyledInput = styled(AutoResizeInput)`
  height: ${(props) => (props.type === 'withBreadCrumbs' ? '36px' : '44px')};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 'bold')};
  font-size: ${(props) => (props.fontSize ? props.fontSize : '16px')};
  color: ${(props) => `${props.theme.colors.text.g1} !important`};
  opacity: 1 !important;

  border-bottom: 1px solid ${(props) => (props.isDisabled ? 'transparent !important' : 'inherit')};
  cursor: ${(props) => (props.isDisabled ? 'default !important' : 'text')};
  ${({ padding }) => padding && `padding :${padding}`};
  overflow-y: auto;
`;

export const HeaderInput = forwardRef(
  ({ type = 'normal', value = '', placeholder = '', onChange = '', isEditable = true, ...props }, ref) => (
    <StyledInput
      type={type}
      autoFocus={false}
      isDashed
      ref={ref}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      isDisabled={!isEditable}
      {...props}
    />
  )
);
